<template>
  <div class="login-mp">
    <div class="form-container">
      <h1 class="form-title">老师账号绑定</h1>
      <h1 class="form-title en-title">Teacher account binding</h1>
      <el-form
        ref="loginForm"
        :model="loginForm"
        autoComplete="off"
        :rules="formRules"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            type="text"
            placeholder="手机号/邮箱 Phone/Email"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="密码 Password"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-button class="login_btn" @click="handleBindUser">绑定 Binding</el-button>
      </el-form>
      <p class="desc-text">在家办公成为一名教育工作者<br>Work from home<br>Become a global educator</p>
    </div>
    <p class="btm_text">
      老师注册地址<br />
      Teacher registration website<br />
      <span v-clipboard="copyData" @success="handleCopySuccess">https://t.bingotalk.cn</span>
    </p>
  </div>
</template>

<script>
import { validateEmail } from '@/utils/validate.js'

export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号或邮箱 Phone/Email required"));
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(value)) {
        if (!validateEmail(value)) {
          callback(new Error("请输入正确的手机号或邮箱 Need valid Phone/Email"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
    return {
      appid: 'wx62846c50b2add1f9',
      redirect_uri: encodeURIComponent(window.location),
      code: '',
      copyData: 'https://t.bingotalk.cn',
      loginForm: {
        username: '',
        password: ''
      },
      formRules: {
        username: [
          {
            required: true,
            trigger: "blur",
            validator: validateUsername
          }
        ],
        password: [
          {
            required: true,
            min: 6,
            max: 14,
            message: '请输入长度6-14位的密码 6 to 14 characters required',
            trigger: "blur"
          }
        ]
      }
    };
  },
  created () {
    this.handleMpLogin();
  },
  methods: {
    getMpCode() {
      this.code = this.getQueryString('code')
      const baseUrl = window.location.href.split('?code')[0]
      if (!this.code) {
        // window.location.href = `${process.env.GET_WECHAT_CODE}?appid=${this.appid}&scope=snsapi_userinfo&state=123&redirect_uri=${this.redirect_uri}`
        // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${this.redirect_uri}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
        window.location.href = `https://t.bingomate.cn/get-weixin-code.html?appid=${this.appid}&scope=snsapi_userinfo&state=123&redirect_uri=${this.redirect_uri}`
      } else {
        this.$store
        .dispatch("LoginByMp", {
          userType: 'TEACHER',
          loginType: 'WECHAT_GZH',
          authCode: this.code
        })
        .then(response => {
          if (response.status === 200) {
            if (response.data !== "" && response.data.code === 200) {
              window.location.href = baseUrl + '#/m/home'
            } else {
              console.log('newnewnew')
            }
          } else {
            console.log('1111')
          }
        })
        .catch(error => {
          console.log(error)
          window.location.href = baseUrl + '#/m/login'
        });
      }
    },
    getQueryString(name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      const result = window.location.search.substring(1).match(reg);
      if (result != null) {
        return decodeURIComponent(result[2]);
      }
      return null;
    },
    handleMpLogin() {
      this.getMpCode()
    },
    handleBindUser() {
      const baseUrl = window.location.href.split('?code')[0]

      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$store
          .dispatch("BindUser", {
            userType: 'TEACHER',
            loginType: 'WECHAT_GZH',
            authCode: this.code,
            mobileOrEmail: this.loginForm.username,
            password: this.loginForm.password
          }).then(response => {
            if (+response.status === 200) {
              if (response.data !== "" && +response.data.code === 200) {
                window.location.href = baseUrl + '#/m/home'
              } else {
                this.$message.error(response.data.message);
                setTimeout(() => {
                  window.location.href = baseUrl + '#/m/login'
                }, 500)
              }
            } else {
              this.$message.error(this.$t('lang.loginPage23'));
              setTimeout(() => {
                window.location.href = baseUrl + '#/m/login'
              }, 500)
            }
          })
          .catch(error => {
            console.log(error)
            this.$message.error(this.$t('lang.loginPage23'));
            setTimeout(() => {
              window.location.href = baseUrl + '#/m/login'
            }, 500)
          });
        }
      });
    },
    handleCopySuccess() {
      this.$message.success('复制成功 Copy Success');
    }
  }
};
</script>

<style lang="scss">
.login-mp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 750px;
  height: 100vh;
  margin: 0 auto;
  font-size: 20px;
  color: #4a4a4a;

  .login_btn {
    align-self: center;
    width: 100%;
    height: 46px;
    background: #ffe300;
    outline: none;
    border: none;
    border-radius: 0;
    font-size: 14px;
    font-weight: 500;
    color: #4a4a4a;
  }

  .el-input {
    background: #ffffff;

    .el-input__inner {
      height: 46px;
      border-radius: 0;
      background: #ffffff;
      border: 2px solid #ffda5c;
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .form-container {
    margin: 14vh 10vw 0;
  }

  .el-tabs__header {
    font-size: 20px;
    .el-tabs__nav {
      display: flex;
      justify-content: space-between;
      width: 200px;
      margin: 0 auto;
      float: none;

      .el-tabs__active-bar {
        background-color: #ffdd02;
      }

      .el-tabs__item {
        margin: 0;
        width: 100px;
        font-size: 20px;
        text-align: center;
        font-weight: 500;
        color: #4a4a4a;
      }
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
  }

  .el-form {
    display: flex;
    flex-direction: column;
  }

  .el-form-item {
    margin-bottom: 32px;
  }

  .el-form-item__error {
    left: 15px;
  }

  .form-title {
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    margin: 0 0 6px;
  }

  .en-title {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 16px;
  }

  .desc-text {
    width: 230px;
    height: 60px;
    margin: 54px auto 0;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #2d2d2d;
    line-height: 20px;
  }

  .btm_text {
    margin: 10px auto 36px;
    width: 230px;
    height: 60px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #2d2d2d;
    line-height: 20px;

    span {
      color: #f5a623;
    }

    .copy-btn {
      margin: 0;
      padding: 0;
      font-size: 12px;
      font-weight: 500;
      border: none;
      background: none;
      outline: none;
      color: #f5a623;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/login-mp.vue